/* ============================================================
   kuno-bilder.js  ·  Stand 10.09.2026
   Kartenbilder in Kartengroesse.

   Die Bilder des Shops tragen ein srcset und werden in passender
   Groesse ausgeliefert. Kunos Karten tragen weder srcset noch
   sizes - nur ein src auf das Original. Gemessen am 29.08.2026:
   bis 1935 Pixel breit und ueber 1 MB schwer fuer eine Karte von
   199 Pixel. Bei 87 Treffern kommt so ein Vielfaches dessen
   zusammen, was noetig waere.

   Shopifys CDN liefert auf Wunsch eine kleinere Fassung. Ein
   angehaengtes width=600 macht aus 1344 KB rund 53 KB und reicht
   fuer Karten bis 200 Pixel, auch auf Retina-Bildschirmen.

   Umgeschrieben wird, sobald eine Karte entsteht - vor dem Laden,
   damit kein Bild zweimal ueber die Leitung geht.

   Zusaetzlich bekommen die Karten im ersten Sichtfeld
   loading="eager". Ein Bild im ersten Sichtfeld gehoert nicht
   verzoegert geladen, alles weiter unten bleibt lazy.

   Am 10.09.2026 angepasst: Rezeptantworten zeigen jetzt 24 Karten
   statt acht, das sind am Rechner vier Reihen. Acht eager waren
   auf die alte Zahl gerechnet. Am Rechner stehen rund zwei Reihen
   im ersten Sichtfeld, auf dem Handy bei zwei Spalten rund drei -
   deshalb 12 beziehungsweise 6 statt einer festen Zahl. Mehr
   waeren auf dem Handy nur Datenmenge ohne Nutzen.

   Am 29.08.2026 sah es kurz so aus, als wuerde loading="lazy"
   hier nie ausloesen. Die Gegenprobe auf einer fremden Seite
   zeigte den Fehler im Browser, nicht im Shop. Merksatz: einen
   Anzeigefehler erst auf einer zweiten Seite und in einem
   zweiten Browser bestaetigen, bevor man ihn dem eigenen Code
   zuschreibt.

   Laeuft als letzte Schicht, damit sie alles sieht, was die
   anderen erzeugen.
   ============================================================ */
(function () {
  'use strict';

  var BREITE = 600;

  /* So viele Karten stehen im ersten Sichtfeld. */
  function oben() {
    var breit = (typeof window !== 'undefined' && window.innerWidth) || 1200;
    return breit < 750 ? 6 : 12;
  }

  function klein(u) {
    if (!u || u.indexOf('cdn.shopify.com') < 0) return u;
    if (/[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + BREITE;
  }

  function anpassen(img, obenAuf) {
    if (img.getAttribute('data-kuno-bild')) return false;
    img.setAttribute('data-kuno-bild', '1');
    if (obenAuf && img.getAttribute('loading') === 'lazy') {
      img.setAttribute('loading', 'eager');
    }
    if (img.getAttribute('srcset')) return true;      /* kuemmert sich selbst */
    var s = img.getAttribute('src');
    if (!s) return true;
    var neu = klein(s);
    if (neu === s) return true;
    /* Ein bereits geladenes Bild nicht neu holen - das gaebe ein Flackern. */
    if (img.complete && img.naturalWidth) return true;
    img.setAttribute('src', neu);
    return true;
  }

  function durchgehen(wurzel) {
    var b = wurzel.querySelectorAll('img:not([data-kuno-bild])'), grenze = oben(), i;
    for (i = 0; i < b.length; i++) anpassen(b[i], i < grenze);
  }

  function start() {
    var panel = document.getElementById('frag-kuno');
    if (!panel) return;
    durchgehen(panel);
    /* Die Karten entstehen erst bei der Antwort. Beobachtet wird nur
       childList - die eigenen src-Wechsel loesen den Beobachter
       deshalb nicht aus. */
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () { durchgehen(panel); })
        .observe(panel, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  if (typeof window !== 'undefined') window.KUNO_BILDER = '2026-09-10';
})();
